"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./heading.css");
var _excluded = ["bottomBorder", "children", "className", "autoFocus", "size", "tagName"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A component for marking up page headings. Provide the component a `tagName` appropriate for the
 * current [document outline](http://html5doctor.com/outlines/), and a standardized `size`.
 * Additional visual styling can be accomplished by passing in `text-*` utility classes.
 *
 * By separating the visual style and HTML element of heading elements, we can ensure that pages
 * have appropriate, accessible document outlines without having to worry about changing visuals.
 *
 * For more information, see
 * [Managing Typography on Large Apps](http://csswizardry.com/2016/02/managing-typography-on-large-apps/)
 * and
 * [Abandoning Global Heading Styles](http://www.alexlande.com/articles/abandoning-global-heading-styles/).
 */
var Heading = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var bottomBorder = _ref.bottomBorder,
    children = _ref.children,
    className = _ref.className,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    size = _ref.size,
    TagName = _ref.tagName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var headingRef = (0, _react.useRef)();
  // if the consumer passed in a ref, merge with the locally created one.
  (0, _react.useImperativeHandle)(ref, function () {
    return headingRef.current;
  });
  var classList = (0, _classnames["default"])('sb-heading', _defineProperty(_defineProperty({}, "text-".concat(size), Boolean(size)), className, Boolean(className)));
  var getChildren = function getChildren() {
    return bottomBorder ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "sb-heading__bottomBorder block"
    }, children) : children;
  };
  (0, _react.useEffect)(function () {
    if (autoFocus) {
      var _headingRef$current, _headingRef$current$f;
      headingRef === null || headingRef === void 0 || (_headingRef$current = headingRef.current) === null || _headingRef$current === void 0 || (_headingRef$current$f = _headingRef$current.focus) === null || _headingRef$current$f === void 0 || _headingRef$current$f.call(_headingRef$current);
    }
  }, [autoFocus]);
  return /*#__PURE__*/_react["default"].createElement(TagName, _extends({
    className: classList,
    ref: headingRef,
    tabIndex: "-1"
  }, otherProps), getChildren());
});
Heading.displayName = 'Heading';
Heading.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Use this prop to move focus to a heading. For accessibility,
   * focus should in various conditions be moved to an existing heading.
   * This is particularly relevant for the page heading (h1)
   * on single page app transitions, but should NOT be used for an
   * initial page load from the server, as in that case the user
   * should be afforded the chance to experience the site navigation.
   */
  autoFocus: _propTypes["default"].bool,
  /**
   * Creates a stylized bottom border beneath the text
   */
  bottomBorder: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  /**
   * These map to standard `text-*` utility classes. An alternative to the size prop is to
   * specify a `text-*` className, but headings will likely evolve to include refined
   * letter-spacing and line-height per size, so it's best to stick with the size props.
   */
  size: _propTypes["default"].oneOf(['xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']),
  /**
   * The HTML tagName or React component to be rendered. This should almost always be an
   * `h1`&ndash;`h6` element that forms a correct
   * [document outline](http://html5doctor.com/outlines/).
   */
  tagName: _propTypes["default"].any.isRequired
} : {};
var _default = exports["default"] = Heading;